const sortYearly = (yearly: Record<string, string>): Array<[string, string]> => {
  return Object.entries(yearly).sort(([leftYear], [rightYear]) => parseInt(rightYear) - parseInt(leftYear))
}

export { sortYearly }
